import { useQuery } from 'react-query';

import { RegistrationSettings } from '../../../types/RegistrationSettings';
import Api from '../../api/api';

export const getRegistrationSettings = async (): Promise<RegistrationSettings> => {
  const [response, bodyOrError] = await Api.get('registration-settings');

  if (!response.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const useGetRegistrationSettings = () =>
  useQuery('getRegistrationSettings', getRegistrationSettings);
